import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { PoBreadcrumb, PoTableColumnSpacing } from '@po-ui/ng-components';
import { PoPageDynamicEditActions, PoPageDynamicEditField } from '@po-ui/ng-templates';
import { SchemaBuilderService } from '../../../../core/menu/schema-builder.service';

@Component({
  selector: 'app-regras-cte-edit',
  templateUrl: './regras-cte-edit.component.html',
  styleUrls: ['./regras-cte-edit.component.css'],
  standalone: false
})
export class RegrasCteEditComponent implements OnInit {


  readonly serviceApi = `${environment.apiUrl}${environment.versionApi}/xml/cte-regras`;

  public readonly breadcrumb: PoBreadcrumb = {
      items: [{ label: 'Home', link: '/' }, { label: 'Cadastro de Regras (CT-e)', link: '/regras-cte' }, { label: 'Edição Regras' }]
  };

  public readonly actions: PoPageDynamicEditActions = {
      save: 'regras-cte',
      // saveNew: '/cliente',
  };

  fields: PoPageDynamicEditField[] = []
  poTableColumnSpacing: PoTableColumnSpacing = PoTableColumnSpacing.Small;


  constructor(private readonly schemaBuilderService: SchemaBuilderService) { }

  ngOnInit(): void {
    this.schemaBuilderService.getFieldSchema("cteregras").subscribe((data) => {
        this.fields = data;
    });
  }

}
